const OPENAI_ADS_PIXEL_ID = "3kMKaF8c1rsff8zJP2dec3";
const OPENAI_ADS_SDK_URL = "https://bzrcdn.openai.com/sdk/oaiq.min.js";

let advertisementConsentGranted = false;
let initialConsentResolved = false;
let listenersInitialized = false;
let pixelInitialized = false;
let pendingInitialMeasurements = [];
const claimedMeasurements = new Set();
let registrationCompletedMeasurementArmed = false;

function hasAdvertisementConsent(consent) {
  return !!(
    consent &&
    consent.isUserActionCompleted === true &&
    consent.categories &&
    consent.categories.advertisement === true
  );
}

function initializePixel() {
  if (!advertisementConsentGranted || pixelInitialized) {
    return;
  }

  if (!window.oaiq) {
    const queue = function () {
      queue.q.push(arguments);
    };
    queue.q = [];
    window.oaiq = queue;

    const script = document.createElement("script");
    script.async = true;
    script.src = OPENAI_ADS_SDK_URL;
    const firstScript = document.getElementsByTagName("script")[0];

    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }
  }

  window.oaiq("init", {
    pixelId: OPENAI_ADS_PIXEL_ID,
  });
  pixelInitialized = true;
}

function resolveInitialConsent(consent) {
  if (initialConsentResolved) {
    return;
  }

  initialConsentResolved = true;
  advertisementConsentGranted = hasAdvertisementConsent(consent);

  const measurements = pendingInitialMeasurements;
  pendingInitialMeasurements = [];

  if (!advertisementConsentGranted) {
    return;
  }

  initializePixel();
  measurements.forEach((measure) => measure());
}

function handleConsentUpdate(event) {
  // Measurements made before a new consent choice must never be replayed.
  if (!initialConsentResolved) {
    initialConsentResolved = true;
    pendingInitialMeasurements = [];
  }

  const accepted = event && event.detail && event.detail.accepted;
  advertisementConsentGranted = Array.isArray(accepted) && accepted.includes("advertisement");

  if (advertisementConsentGranted) {
    initializePixel();
  }
}

export function initializeOpenAiAds() {
  if (listenersInitialized || typeof window === "undefined") {
    return;
  }

  listenersInitialized = true;

  document.addEventListener("cookieyes_banner_load", (event) => {
    resolveInitialConsent(event.detail);
  });
  document.addEventListener("cookieyes_consent_update", handleConsentUpdate);

  if (typeof window.getCkyConsent === "function") {
    try {
      resolveInitialConsent(window.getCkyConsent());
    } catch {
      resolveInitialConsent(null);
    }
  }
}

export function measureOpenAiAdsOnce(key, eventName, payload) {
  if (typeof window === "undefined" || claimedMeasurements.has(key)) {
    return;
  }

  claimedMeasurements.add(key);

  const measure = () => {
    if (!advertisementConsentGranted) {
      return;
    }

    initializePixel();
    window.oaiq("measure", eventName, payload);
  };

  if (!initialConsentResolved) {
    pendingInitialMeasurements.push(measure);
    return;
  }

  measure();
}

export function armRegistrationCompletedMeasurement() {
  registrationCompletedMeasurementArmed = true;
}

export function disarmRegistrationCompletedMeasurement() {
  registrationCompletedMeasurementArmed = false;
}

export function measureRegistrationCompletedIfArmed() {
  if (!registrationCompletedMeasurementArmed) {
    return;
  }

  registrationCompletedMeasurementArmed = false;
  measureOpenAiAdsOnce("registration-completed", "registration_completed", {
    type: "customer_action",
  });
}
